import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import {
  ReceivableSearchRequest,
  ParamPaymentChannelInstructions,
} from "../models/receivable";

@Injectable({
  providedIn: "root",
})
export class ReceivableService extends BaseService {
  getSummary(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get("account_receivable/summary").subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getReceivable(
    param: ReceivableSearchRequest,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `v3/account-receivable?Limit=${param.lim}&Offset=${param.off}&Status=${param.filter}`
    ).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getUserTransaction(
    filter: number,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `v2/user-transactions?Limit=100&Offset=0&Filter=${filter}`
    ).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getUserTransactionDetail(
    id: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`v2/user-transactions/${id}`).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getPaymentChannel(
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get("/v2/payment-channels").subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getPaymentChannelInstructions(
    param: ParamPaymentChannelInstructions,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `/v2/payment-channel-instructions?PaymentChannelId=${param.PaymentChannelId}&VaNumber=${param.VaNumber}`
    ).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getReturnBatch(
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      'return/count_sap_return'
    ).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );

  }

  getReturnInfo(
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      'return/return_info'
    ).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getReturnList(
    start: string,
    end: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `return/get_sap_return?Start=${start}&End=${end}`
    ).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }
}
